import axios from "axios";

const URL = {
  base: "/api/cdk/customer/v1",
  customerList: "/customer-list/"
};

const HEADERS = {
  "Content-Type": "application/json"
};

const CustomersService = {
  getCustomers: async (customerName, customerType = 4) => {
    try {
      const response = await axios.get(
        `${URL.base}${URL.customerList}${customerName}/${customerType}`,
        { headers: HEADERS }
      );
      const customers = response.data;

      return customers;
    } catch (e) {
      console.error(
        "An error has occurred while trying to get the customers",
        e
      );
      return { hasError: true };
    }
  }
};

export default CustomersService;
